import React, { Component } from "react";

class ExternalLink extends Component {
  render() {
    return (
      <a
        href={this.props.href || this.props.to}
        target="_blank"
        rel="noopener noreferrer"
        className={this.props.className}>
        {this.props.children}
      </a>
    );
  }
}

export default ExternalLink;
